import { fetcher } from "../../utils/fetcher.js";

export const getAllNotes = (showCompleted, projectId) => {
  const params = [];
  if (showCompleted !== undefined)
    params.push(`showCompleted=${showCompleted}`);
  if (projectId) params.push(`projectId=${projectId}`);
  const query = params.length ? `?${params.join("&")}` : "";
  return fetcher.get(`/api/notes${query}`);
};
